import axiosInstance from '../utils/axiosInstance.js';
import { route_get_firmwares, route_update_firmwares } from '../constants/BackendRoutes.js';

/**
 * Updates a single devices firmware
 * @param {string} deviceId id of the device
 * @param {string} firmwareVersion version of firmware
 */
export async function sendFirmwareUpdate(deviceId, firmwareVersion) {
  const encodedFirmware = encodeURIComponent(`${firmwareVersion}`);
  const url = `${route_update_firmwares}/${deviceId}/${encodedFirmware}`;
  console.log(url);
  try {
    axiosInstance.post(url);
  } catch (error) {
    if ('status' in error)
    {
      console.log(`Backend not responding: ${error.status} error`);
    }
    else
    {
      console.error("Error updating firmware: ", error);
    }
    return null;
  }
}

/**
 * Fetches the list of all firmware versions for the device type
 * @param {string} deviceType type of device, e.g. Actuator
 * @returns list of firmware versions from the device type
 */
export async function fetchFirmwareList(deviceType) {
  try {
    // Fetch firmware list from backend
    const url = `${route_get_firmwares}/${deviceType}`;
    console.log(url);
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    if ('status' in error)
    {
      console.log(`Backend not responding: ${error.status} error`);
    }
    else
    {
      console.error("Error fetching firmware list:", error);
    }
    return null;
  }
}